import { ActionsUnion, createAction } from "@bookingcom/flights-core";
import { LoadingStep } from "./state";

export enum ActionTypes {
  setLoadingStep = "loadingSteps/setLoadingStep",
  clearLoadingStep = "loadingSteps/clearLoadingStep",
  setLoadingStepsEnabled = "loadingSteps/setLoadingStepsEnabled"
}

export const actions = {
  setLoadingStep: createAction((step: LoadingStep) => ({
    type: ActionTypes.setLoadingStep,
    payload: { step }
  })),

  setLoadingStepsEnabled: createAction(() => ({
    type: ActionTypes.setLoadingStepsEnabled,
    payload: {}
  })),

  clearLoadingStep: createAction(() => ({
    type: ActionTypes.clearLoadingStep,
    payload: {}
  }))
};

export type Actions = ActionsUnion<typeof actions>;
